import React, { forwardRef } from "react";
import { FiChevronDown } from "react-icons/fi";

/**
 * Styled native <select> (keeps full native behaviour/accessibility).
 */
const Select = forwardRef(function Select({ label, className = "", containerClassName = "", children, ...props }, ref) {
    return (
        <div className={containerClassName}>
            {label && (
                <label className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                    {label}
                </label>
            )}
            <div className="relative">
                <select ref={ref} className={`field-base appearance-none pr-10 ${className}`} {...props}>
                    {children}
                </select>
                <FiChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            </div>
        </div>
    );
});

export default Select;
